import React from 'react';
import { styled } from '@compiled/react';
import { lazy } from 'react-loosely-lazy';
import Spinner from '@atlaskit/spinner';
import Placeholder from '@atlassian/jira-placeholder';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const DeploymentsEmptyState = lazy(
	() => import(/* webpackChunkName: "async-deployments-empty-state" */ './main'),
);

export const AsyncDeploymentsEmptyState = () => (
	<Placeholder
		name="deployments-empty-state"
		fallback={
			<SpinnerWrapper>
				<Spinner size="large" />
			</SpinnerWrapper>
		}
	>
		<DeploymentsEmptyState />
	</Placeholder>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerWrapper = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '100%',
});
